"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _get = _interopRequireDefault(require("lodash/get"));
var _SignupFormComponent = _interopRequireDefault(require("./SignupFormComponent"));
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _apex = require("../../apex");
var _signupActions = require("../../redux/actions/signupActions");
var _wsHelper = require("../../helpers/wsHelper");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SignupFormForm = (0, _reduxForm.reduxForm)({
  form: 'signup',
  onSubmit: function onSubmit(payload, dispatch, _props) {
    (0, _apex.setGateway)(payload.gateway);
    return dispatch((0, _signupActions.signup)(payload)).then(function (response) {
      if (response && response.errormsg) {
        /**
         * To leverage `redux-form` field-specific error functionality,
         *  we must throw a `SubmissionError` from decorated component's `handleSubmit` prop.
         */
        throw new _reduxForm.SubmissionError((0, _errorTextFormatter.preprocessErrorTextForReduxForm)(response.errormsg, payload));
      }
    });
  }
})(_SignupFormComponent["default"]);
var selector = (0, _reduxForm.formValueSelector)('signup');
var gateway = (0, _wsHelper.getLoginFormGateway)();
var mapStateToProps = function mapStateToProps(state) {
  return _objectSpread({
    passwordValue: selector(state, 'password'),
    errorMsg: (0, _get["default"])(state, 'form.signup.error', false),
    isConnected: state.wsConnection.isConnected,
    done: !!state.signup.userId,
    isAuthenticated: state.auth.isAuthenticated,
    siteName: _config["default"].global.siteName,
    gateway: gateway,
    formGateway: selector(state, 'gateway')
  }, _config["default"].SignupForm);
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetGateway: function resetGateway() {
      return dispatch((0, _reduxForm.change)('signup', 'gateway', ''));
    },
    clearSignupError: _signupActions.clearSignupError
  };
};
var SignupFormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SignupFormForm);
var _default = exports["default"] = SignupFormContainer;